import { jsx as _jsx } from "react/jsx-runtime";
import { CError } from "./CError";
const CApolloError = ({ header, error }) => {
    return (_jsx(CError, { header: header || "Error", error: error?.message ?? "An unexpected error has occured" }));
};
export { CApolloError };
